import { getCookie } from "@jti/fe-common";

export const productsOwnedCookieName = "productsOwned";

export const getProductsOwnedCookie = (): string[] => {
  const productsOwned = getCookie(productsOwnedCookieName);

  if (typeof productsOwned !== "string" || !productsOwned.trim()) {
    return [];
  }

  try {
    const parsedProducts = JSON.parse(productsOwned);

    if (Array.isArray(parsedProducts)) {
      return parsedProducts.filter((item): item is string => typeof item === "string" && Boolean(item.trim()));
    }
  } catch {
    return productsOwned
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
};
